// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3n6M7","left":"InfoRow_left__3yIb6"};